"use strict";

import {initAjaxFormMap} from "@elements/ajax-form-map/ajax-form-leaflet";
import {onFind} from "@elements/init-modules-in-scope";
import {find, findIn} from "@elements/dom-utils";
import * as leafletMap from "@elements/leaflet-map";


const infoBoxOptions = {
    maxWidth: matchMedia('(max-width: 767px)').matches ? 250 : 320,
    minWidth: matchMedia('(max-width: 767px)').matches ? 230 : 300,
    className: 'map-infobox'
};

export function init() {
    onFind('.js-ajax-form-map-leaflet', function (baseElement) {
        let mapCanvas = findIn('.js-ajax-form-map-leaflet__map-canvas', baseElement);
        initAjaxFormMap(baseElement, {
            element: mapCanvas,
            tilelayer: 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}',
            leafletOptions: {
                attribution: '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>',
                maxZoom: 18,
                id: 'mapbox/light-v10',
                accessToken: _config.mapAccessToken
            },
            mapOptions: {
                center: {lat: 47.01011105170685, lng: 8.482870389663853},
                zoom: 15,
                maxZoom: 18,
            },
            poiStyles: () => createPoiStyles(),
            infoBoxOptions,
            clustering: true,
            clusteringOptions: () => clusteringOptions(),
            onActivateMarker: (marker, api) => onActivateMarker(marker, api),
            onDeactivateMarker: (marker, api) => onDeactivateMarker(marker, api),
        });

        let fullScreenBtn = findIn('.js-interactive-map__custom-fullscreen', baseElement);

        fullScreenBtn.addEventListener('click', function (e){
            e.preventDefault();
            let mapContainer = baseElement;
            let openFullScreenText = findIn('.js-interactive-map__custom-fullscreen--open', baseElement);
            let closeFullScreenText = findIn('.js-interactive-map__custom-fullscreen--close', baseElement);

            if(!mapContainer.classList.contains('is-fullscreen')) {
                mapContainer.classList.add('is-fullscreen');
                closeFullScreenText.removeAttribute('hidden');
                openFullScreenText.setAttribute('hidden', true);

            } else {
                mapContainer.classList.remove('is-fullscreen');
                closeFullScreenText.setAttribute('hidden', true);
                openFullScreenText.removeAttribute('hidden');
            }

            leafletMap.getApi(mapCanvas).then((api) => {
                let map = api.getMapInstance();
                console.log(map);
                map.invalidateSize();
            });

        });

    });
}


function clusteringOptions() {
    return {
        showCoverageOnHover: false,
        iconCreateFunction: function (cluster) {
            return L.divIcon({
                iconSize: [36, 36],
                iconAnchor: [18, 18],
                className: 'marker-cluster',
                html: '<div class="marker-cluster__img"><img src="/static/img/map/cluster.svg"/><span class="marker-cluster__count">' + cluster.getChildCount() + '</span></div>'
            });
        }
    };
}

function createPoiStyles() {
    return {
        main: {
            default: L.icon({
                iconUrl: '/static/img/map/poi.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/poi.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            })
        },
        secondary: {
            default: L.icon({
                iconUrl: '/static/img/map/poi-secondary.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/poi-secondary.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            })
        },
        red: {
            default: L.icon({
                iconUrl: '/static/img/map/poi-red.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/poi-red.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            })
        },
        orange: {
            default: L.icon({
                iconUrl: '/static/img/map/mapmarker-gastro.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/mapmarker-gastro.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            })
        },
        blue: {
            default: L.icon({
                iconUrl: '/static/img/map/mapmarker-accomodation.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/mapmarker-accomodation.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            })
        },
        green: {
            default: L.icon({
                iconUrl: '/static/img/map/mapmarker-events.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/mapmarker-events.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            })
        },
        brown: {
            default: L.icon({
                iconUrl: '/static/img/map/mapmarker-activity.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/mapmarker-activity.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            })
        },
        beach: {
            default: L.icon({
                iconUrl: '/static/img/map/mapmarker-beach.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/mapmarker-beach.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            })
        },
        bus: {
            default: L.icon({
                iconUrl: '/static/img/map/mapmarker-bus-station.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/mapmarker-bus-station.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            })
        },
        diving: {
            default: L.icon({
                iconUrl: '/static/img/map/mapmarker-diving.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/mapmarker-diving.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            })
        },
        fire: {
            default: L.icon({
                iconUrl: '/static/img/map/mapmarker-fire.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/mapmarker-fire.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            })
        },
        information: {
            default: L.icon({
                iconUrl: '/static/img/map/mapmarker-information.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/mapmarker-information.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            })
        },
        museum: {
            default: L.icon({
                iconUrl: '/static/img/map/mapmarker-museum.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/mapmarker-museum.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            })
        },
        parking: {
            default: L.icon({
                iconUrl: '/static/img/map/mapmarker-parking.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/mapmarker-parking.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            })
        },
        photopoint: {
            default: L.icon({
                iconUrl: '/static/img/map/mapmarker-photopoint.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/mapmarker-photopoint.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            })
        },
        playground: {
            default: L.icon({
                iconUrl: '/static/img/map/mapmarker-playground.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/mapmarker-playground.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            })
        },
        port: {
            default: L.icon({
                iconUrl: '/static/img/map/mapmarker-port.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/mapmarker-port.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            })
        },
        shopping: {
            default: L.icon({
                iconUrl: '/static/img/map/mapmarker-shopping.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/mapmarker-shopping.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            })
        },
        toilets: {
            default: L.icon({
                iconUrl: '/static/img/map/mapmarker-toilets.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/mapmarker-toilets.svg',
                iconSize: [30, 45],
                iconAnchor: [15, 45],
                popupAnchor: [-154, -16],
            })
        }

    };

}


function onActivateMarker(marker, api) {
    console.log("on activate marker");
    if (marker.detailInfoBoxUrl) {
        let infoBoxPromise = api.showInfoBoxByMarker(
            marker,
            ` <div class="loading-spinner" aria-label="loading...">
                    <div class="loading-spinner__item loading-spinner__item--1"></div>
                    <div class="loading-spinner__item loading-spinner__item--2"></div>
                    <div class="loading-spinner__item loading-spinner__item--3"></div>
                </div>`
        );

        let contentPromise = fetch(marker.detailInfoBoxUrl, {
            method: 'GET',
            headers: {"content-type": "application/json"}
        }).then((res) => {
            return res.json()
        });


        Promise.all([infoBoxPromise, contentPromise]).then(([infoBox, response]) => {
            infoBox.setContent(response.html);
        });

    }
}

function onDeactivateMarker(marker, mapObj) {
     console.log("on deactivate marker");
}

